import React from "react";
import { Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "./ui/alert-dialog";

export const ConfirmPhotoDelete = ({ photo, busy, onCancel, onConfirm }) => (
    <AlertDialog open={!!photo} onOpenChange={(open) => { if (!open && !busy) onCancel(); }}>
        <AlertDialogContent className="portal-confirm-dialog" data-testid="photo-delete-dialog" overlayClassName="z-[100]" overlayTestId="photo-delete-overlay">
            <AlertDialogHeader>
                <AlertDialogTitle data-testid="photo-delete-title">Remove this photo?</AlertDialogTitle>
                <AlertDialogDescription data-testid="photo-delete-description" className="break-words">
                    {photo?.original_filename || "This photo"} will be removed from your library. This cannot be undone.
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel disabled={busy} onClick={onCancel} data-testid="photo-delete-cancel">Keep photo</AlertDialogCancel>
                <AlertDialogAction disabled={busy} onClick={(event) => { event.preventDefault(); onConfirm(); }}
                    data-testid="photo-delete-confirm" className="bg-red-700 text-white hover:bg-red-600">
                    {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Remove photo
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
);